(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-bundle-colour-siblings"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // Get the parent bundle handle from the data attribute for tracking with each line item
    var bundleComponent = document.querySelector('colour-sibling[data-usage="main-product"]');
    var bundleParentHandle = bundleComponent ? bundleComponent.dataset.bundleParentHandle : null;
    // Prefer sibling label when grouping is by size; otherwise show the colour title.
    function getDisplayColourName(thumbnail) {
      return thumbnail.dataset.groupBySize === 'true' && thumbnail.dataset.siblingName
        ? thumbnail.dataset.siblingName
        : thumbnail.dataset.colourName;
    }

    // Enforce one valid selection per group and keep the heading label in sync.
    function normalizeGroupSelection(groupEl, fallbackLabelSpan) {
      var labelSpan = groupEl.querySelector('.colour-group__selection-label') || fallbackLabelSpan;
      // Only consider selectable, in-stock thumbnails that map to a variant.
      var availableThumbs = groupEl.querySelectorAll(
        '.product-form__thumbnail-label[data-variant-id]:not(.product-form__option--unavailable)'
      );

      if (!availableThumbs.length) {
        // If a group has no valid options, clear stale selected state.
        groupEl.querySelectorAll('.product-form__thumbnail-label.product-selected').forEach(function (t) {
          t.classList.remove('product-selected');
        });
        return;
      }

      // Keep only in-stock selected thumbnails when determining active state.
      var selectedAvailableThumbs = groupEl.querySelectorAll(
        '.product-form__thumbnail-label.product-selected[data-variant-id]:not(.product-form__option--unavailable)'
      );

      if (!selectedAvailableThumbs.length) {
        // Default to first available option if selection is missing/invalid.
        groupEl.querySelectorAll('.product-form__thumbnail-label.product-selected').forEach(function (t) {
          t.classList.remove('product-selected');
        });
        availableThumbs[0].classList.add('product-selected');
        selectedAvailableThumbs = [availableThumbs[0]];
      }

      if (selectedAvailableThumbs.length > 1) {
        // Guard against duplicate selected classes by keeping the first one.
        var keepThumb = selectedAvailableThumbs[0];
        groupEl.querySelectorAll('.product-form__thumbnail-label.product-selected').forEach(function (t) {
          if (t !== keepThumb) t.classList.remove('product-selected');
        });
        selectedAvailableThumbs = [keepThumb];
      }

      // Reflect effective selection in the visible group label.
      var colourName = getDisplayColourName(selectedAvailableThumbs[0]);
      if (labelSpan && colourName) {
        labelSpan.textContent = colourName;
      }
    }

    // Normalize each bundle group on initial load so UI and data state align.
    function normalizeAllBundleSelections() {
      document.querySelectorAll('colour-sibling[data-usage="main-product"]').forEach(function (component) {
        var componentLabelSpan = component.querySelector('.colour-group__selection-label');
        component
          .querySelectorAll('.colour-group[data-group]:not([data-group="LimitedAndCore"])')
          .forEach(function (groupEl) {
            normalizeGroupSelection(groupEl, componentLabelSpan);
          });
      });
    }

    // Recompute displayed bundle total from selected colour options + fixed bundle items.
    function recalculateBundlePrice() {
      var bundleComponent = document.querySelector('colour-sibling[data-usage="main-product"]');
      if (!bundleComponent) return;

      // Money format and fixed total are provided by Liquid data attributes.
      var moneyFormat = bundleComponent.dataset.moneyFormat || '{{amount}}';
      var fixedPrice = parseInt(bundleComponent.dataset.fixedPrice || '0', 10);
      var selectionTotal = 0;

      // Sum only selected, available variant prices from all groups.
      document
        .querySelectorAll(
          'colour-sibling[data-usage="main-product"] .product-form__thumbnail-label.product-selected[data-variant-price]:not(.product-form__option--unavailable)'
        )
        .forEach(function (t) {
          selectionTotal += parseInt(t.dataset.variantPrice || '0', 10);
        });

      // Update the visible ATC price to match the effective bundle total.
      // Fall back to the parent product price if all options are out of stock (selectionTotal = 0).
      var fallbackPrice = parseInt(bundleComponent.dataset.productPrice || '0', 10);
      var allUnavailable = selectionTotal === 0;
      var grandTotal = (selectionTotal || fallbackPrice) + fixedPrice;
      var formatted = Shopify.formatMoney(grandTotal, moneyFormat);
      var atcPriceEl = document.querySelector('.product-atc__price.product-atc-initial-price');
      if (atcPriceEl) atcPriceEl.textContent = formatted;

      // Hide the ATC button wrapper when all selectable options are out of stock.
      var atcButtonWrapper = document.querySelector('.product-atc__button-wrapper');
      if (atcButtonWrapper) atcButtonWrapper.hidden = allUnavailable;

      // Update the regular price display using the money_with_currency format.
      var moneyWithCurrencyFormat = bundleComponent.dataset.moneyWithCurrencyFormat || moneyFormat;
      var formattedWithCurrency = Shopify.formatMoney(grandTotal, moneyWithCurrencyFormat);
      var bundleSectionId = bundleComponent.dataset.section;
      var bundleSectionRoot = document.getElementById('ProductInfo-' + bundleSectionId);
      var priceItemEl = bundleSectionRoot
        ? bundleSectionRoot.querySelector('.price__regular .price-item')
        : document.querySelector('.price__regular .price-item');
      if (priceItemEl) priceItemEl.textContent = formattedWithCurrency;
      var salePriceItemEl = bundleSectionRoot
        ? bundleSectionRoot.querySelector('.price-item--sale')
        : document.querySelector('.price-item--sale');
      if (salePriceItemEl) salePriceItemEl.textContent = formattedWithCurrency;
    }

    // Ensure initial selected state and price are valid before interaction.
    normalizeAllBundleSelections();
    recalculateBundlePrice();

    // ------------------------------------------
    // 1. Colour selection behaviour
    // ------------------------------------------
    document.querySelectorAll('colour-sibling[data-usage="main-product"]').forEach(function (component) {
      var componentLabelSpan = component.querySelector('.colour-group__selection-label');

      component.addEventListener('click', function (event) {
        // Delegate clicks so nested image/icon clicks still resolve to the thumbnail.
        var thumbnail = event.target.closest('.product-form__thumbnail-label');
        if (!thumbnail || !component.contains(thumbnail)) return;

        // Resolve parent group, skipping nested Limited/Core helper grouping.
        var groupEl = thumbnail.closest('.colour-group');
        while (groupEl && groupEl.dataset.group === 'LimitedAndCore') {
          groupEl = groupEl.parentElement.closest('.colour-group');
        }
        if (!groupEl || !component.contains(groupEl)) return;

        var labelSpan = groupEl.querySelector('.colour-group__selection-label') || componentLabelSpan;

        // Prevent anchor navigation and ignore unavailable options.
        event.preventDefault();
        if (thumbnail.classList.contains('product-form__option--unavailable')) return;

        // Keep a single selected thumbnail in the active group.
        groupEl.querySelectorAll('.product-form__thumbnail-label').forEach(function (t) {
          t.classList.remove('product-selected');
        });

        thumbnail.classList.add('product-selected');

        var colourName =
          thumbnail.dataset.groupBySize === 'true' && thumbnail.dataset.siblingName
            ? thumbnail.dataset.siblingName
            : thumbnail.dataset.colourName;
        if (labelSpan && colourName) {
          labelSpan.textContent = colourName;
        }

        // Re-price immediately after every valid selection change.
        recalculateBundlePrice();
      });
    });

    // ------------------------------------------
    // 2. Override add-to-cart on this bundle template
    // ------------------------------------------
    var bundleComponents = document.querySelectorAll('colour-sibling[data-usage="main-product"]');
    if (!bundleComponents.length) return;

    var bundleSectionId = bundleComponents[0].dataset.section;
    var bundleSectionRoot = document.getElementById('ProductInfo-' + bundleSectionId);
    var submitButtons = bundleSectionRoot
      ? bundleSectionRoot.querySelectorAll('.product-form__submit')
      : document.querySelectorAll('.product-form__submit');

    submitButtons.forEach(function (addToCartBtn) {
      // Avoid attaching duplicate capture handlers across section rerenders.
      if (addToCartBtn._bundleClickHandlerAttached) return;
      addToCartBtn._bundleClickHandlerAttached = true;

      addToCartBtn.addEventListener(
        'click',
        function (event) {
          // Always override add-to-cart on this bundle template
          event.preventDefault();
          event.stopImmediatePropagation();

          // Build a variant quantity map before posting to cart.
          var items = [];
          var selectedVariantMap = {};

          // 2.1 Selected colour products from all bundle components
          bundleComponents.forEach(function (bundleComponent) {
            var selectedThumbs = bundleComponent.querySelectorAll(
              '.product-form__thumbnail-label.product-selected[data-variant-id]:not(.product-form__option--unavailable)'
            );
            selectedThumbs.forEach(function (thumb) {
              var variantId = thumb.dataset.variantId;
              if (variantId) {
                // Count every selected occurrence so repeated selections increase quantity.
                selectedVariantMap[variantId] = (selectedVariantMap[variantId] || 0) + 1;
              }
            });
          });

          Object.keys(selectedVariantMap).forEach(function (variantId) {
            items.push({
              id: Number(variantId),
              quantity: selectedVariantMap[variantId],
              properties: { _bundle_source: bundleParentHandle }
            });
          });

          // 2.2 Fixed products from <product-essentials data-product-id="...">
          var fixedEls = bundleSectionRoot
            ? bundleSectionRoot.querySelectorAll('product-essentials[data-product-id]')
            : document.querySelectorAll('product-essentials[data-product-id]');
          fixedEls.forEach(function (el) {
            var fixedVariantId = el.dataset.productId;
            if (!fixedVariantId) return;
            // Fixed products are always included once per bundle add.
            items.push({
              id: Number(fixedVariantId),
              quantity: 1,
              properties: { _bundle_source: bundleParentHandle }
            });
          });

          if (!items.length) {
            // Nothing valid selected; leave without calling cart API.
            return;
          }

          // 2.3 Add everything in one request
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items }),
          })
            .then(function (response) {
              if (!response.ok) {
                // Try to surface Shopify cart error payload when available.
                return response
                  .json()
                  .then(function (errorData) {
                    throw errorData;
                  })
                  .catch(function () {
                    // Fallback if response body isn't JSON.
                    throw new Error('Bundle add failed with status ' + response.status);
                  });
              }
              return response.json();
            })
            .then(function (data) {
              // AFTER ADD: refresh & open cart modal/drawer using theme API or fallback click
              try {
                var cartModal = document.querySelector('cart-modal');
                if (cartModal && typeof cartModal.handleCartLinkClick === 'function') {
                  // Theme-provided cart refresh/open path.
                  cartModal.handleCartLinkClick(new Event('null'));
                } else {
                  // Fallback for themes that open cart via bubble click.
                  var cartLink = document.getElementById('cart-icon-bubble');
                  if (cartLink) cartLink.click();
                }
              } catch (err) {
                console.error('Error opening cart modal after add:', err);
              }
            })
            .catch(function (error) {
              console.error('Error adding bundle items:', error);
            });
        },
        true // capture phase: run before theme's own click handler
      );
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-fixed-bundles"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.product-essentials__product-name').forEach((el) => {
	el.addEventListener(
		'click',
		(event) => {
			event.stopImmediatePropagation();
			event.preventDefault();
		},
		true
	);
});
  } catch(e) { console.error(e); }
})();

})();
